import React, { FunctionComponent, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { IBlockedCategory } from '../../../types'

import { AddBlockCategory } from './AddBlockCategory'
import { AppointmentBlockedCategory } from './AppointmentBlockedCategory'

interface IProps {
  setValue: UseFormSetValue<any>
  blockedCategoryOptions: IBlockedCategory[]
}

export const CategorySelect: FunctionComponent<IProps> = ({
  setValue,
  blockedCategoryOptions,
}) => {
  const [isAddBlockCategory, setIsAddBlockCategory] = useState<boolean>(false)

  if (isAddBlockCategory) {
    return <AddBlockCategory setIsInputFieldOpen={setIsAddBlockCategory} />
  }
  return (
    <AppointmentBlockedCategory
      setValue={setValue}
      blockCategories={blockedCategoryOptions}
      isInputFieldOpen={isAddBlockCategory}
      setIsInputFieldOpen={setIsAddBlockCategory}
    />
  )
}
